/**
 * Single source of truth for cross-cutting types.
 * Phase 0 placeholder — real schemas land in Phase 0.5a.
 */

export const MOVE_SLOTS = ['main', 'secondary1', 'secondary2', 'signature'] as const;
export type MoveSlot = (typeof MOVE_SLOTS)[number];

export const STATUSES = [
  'sleep',
  'poison',
  'toxic',
  'burn',
  'paralysis',
  'freeze',
  'confusion',
] as const;
export type Status = (typeof STATUSES)[number];

export const POKEMON_TYPES = [
  'normal',
  'fire',
  'water',
  'electric',
  'grass',
  'ice',
  'fighting',
  'poison',
  'ground',
  'flying',
  'psychic',
  'bug',
  'rock',
  'ghost',
  'dragon',
] as const;
export type PokemonType = (typeof POKEMON_TYPES)[number];

export interface DataVersioned {
  dataVersion: number;
}
